/**
 * Maps UI / state objects to API bodies expected by backend routes.
 *
 * LDS: POST /getLDSOrdersByAgentId — see HotelsRiver_BE-main_whist/services/LDS_service.py
 *   Known filter keys: order_dates, staying_dates, agent_email, agent_filter_id, paidStatus,
 *   hotel_name,
 *   main_contact, order_id
 *   NOTE: order_id on server matches supplierPNR patterns in JSON, not always internal UUID.
 *
 * Dynamic: POST /getDynamicOrdersByAgentId — expects flat keys (order_date_start, etc.)
 *   DynamicFilters already emits server-shaped objects via convertFiltersToServerFormat.
 */

const LDS_API_FILTER_KEYS = new Set([
  "order_dates",
  "staying_dates",
  "agent_email",
  "agent_filter_id",
  "paidStatus",
  "hotel_name",
  "main_contact",
  "order_id",
  "includeFailedInquiry",
  "include_failed_inquiry",
]);

/**
 * @param {Record<string, unknown>} uiFilters — PackagesFilters state / parent `filters` for LDS tabs
 * @returns {Record<string, unknown>} payload merged into getLDSOrders body
 */
export function ldsPackagesUiFiltersToApiPayload(uiFilters) {
  if (!uiFilters || typeof uiFilters !== "object") {
    return {};
  }
  const out = {};
  Object.keys(uiFilters).forEach((key) => {
    if (!LDS_API_FILTER_KEYS.has(key)) return;
    const v = uiFilters[key];
    if (v === undefined || v === null) return;
    if (typeof v === "string" && v.trim() === "") return;
    out[key] = v;
  });
  return out;
}

/**
 * Admin table bulk load uses flat order_date_start / order_date_end (DD/MM/YYYY).
 */
export function orderDateRangeToFlatApiPayload(startDayjs, endDayjs) {
  return {
    order_date_start: startDayjs.format("DD/MM/YYYY"),
    order_date_end: endDayjs.format("DD/MM/YYYY"),
  };
}

/**
 * Pass-through for dynamic tab: body is already server-normalized.
 */
export function dynamicTabFiltersToApiPayload(serverShapedFilters) {
  if (!serverShapedFilters || typeof serverShapedFilters !== "object") {
    return {};
  }
  return { ...serverShapedFilters };
}
